<template>
    <section class="content-area-wrapper">
        <div class="sidebar-left">
            <div class="sidebar">
                <div class="sidebar-content" :class="{ 'show': showChat }">
                    <span @click="showChat = !showChat" class="sidebar-close-icon">
                        <vue-feather type="x" size="14" />
                    </span>
                    <div class="chat-fixed-search">
                        <div class="d-flex align-items-center w-100">
                            <div class="input-group input-group-merge w-100">
                                <div class="input-group-prepend">
                                    <span class="input-group-text round">
                                        <vue-feather type="search" class="text-muted" size="14" />
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    v-model="chatStore.chats.title"
                                    class="form-control round"
                                    placeholder="Search or start a new chat"
                                    aria-label="Search..."
                                    aria-describedby="chat-search"
                                />
                                <div @click="chatStore.newConversation()" class="input-group-append">
                                    <span class="input-group-text round">
                                        <vue-feather type="plus-circle" class="text-primary" size="14" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="chat-list" class="chat-user-list-wrapper list-group">
                        <h4 class="chat-list-title">Chats</h4>
                        <ul class="chat-users-list chat-list media-list">
                            <li
                                v-if="chatStore.chats.data.length > 0"
                                v-for="chat in chatStore.chats.data"
                                @click="
                                    chatStore.conversations.data.length = 0;
                                    Object.assign(chatStore.activeChat, chat);
                                    chatStore.message = null;
                                    chatStore.conversation();
                                    showChat = false;
                                "
                            >
                                <div class="start-chat-icon align-self-center">
                                    <vue-feather type="message-square" size="24" />
                                </div>
                                <!-- <span class="avatar">
                                    <img
                                        src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/creditfixrr.jpg"
                                        height="52"
                                        width="52"
                                        alt="creditfixrr logo"
                                    />
                                    <span class="avatar-status-offline"></span>
                                </span> -->
                                <div class="px-50 d-flex flex-column w-100">
                                    <small class="mb-25 chat-time">{{ formatDate(chat.created_at, 'LLL') }}</small>
                                    <h5 class="mb-0 d-flex justify-content-between">
                                        <span>
                                            {{ chat.title }}
                                        </span>
                                        <div v-if="chatStore.activeChat.id == chat.id" class="d-flex align-items-center action">
                                            <vue-feather @click="chatStore.editChat()" type="edit" size="14" />
                                            <vue-feather @click="chatStore.deleteChat(chat)" type="trash-2" size="14" />
                                        </div>
                                    </h5>
                                </div>
                            </li>
                            <li v-else>
                                <h6 v-if="chatStore.chats.isLoading == false" class="mb-0">No Chats Found</h6>
                            </li>
                            <li v-if="chatStore.chats.isLoading" class="align-items-center justify-content-center">
                                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                <span class="ml-25 align-middle">Loading...</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="body-content"></div>
        <div class="content-right">
            <div class="content-wrapper">
                <div class="content-body">
                    <div class="chat-app-window">
                        <div v-show="!chatStore.activeChat.id" class="start-chat-area">
                            <header class="chat-header w-100 p-50 bg-white d-block d-lg-none">
                                <div @click="showChat = !showChat" class="sidebar-toggle">
                                    <vue-feather type="menu" class="font-medium-5" size="14" />
                                </div>
                            </header>
                            <div class="row match-height px-1 w-sm-100 w-50 my-auto">
                                <div class="col-12">
                                    <h3 class="text-primary text-center mb-1">Welcome to ChatGPT By</h3>
                                    <div class="d-flex">
                                        <img src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/Marketing/best-diy-credit-repair-software-official-logo.png" class="mb-2 w-50 mx-auto" alt="creditfixrr">
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-4 px-0">
                                    <vue-feather class="mx-auto" type="book-open" size="20" />
                                    <h3 class="text-center">
                                        Examples
                                    </h3>
                                </div>
                                <div class="col-md-4 px-0 d-none d-lg-flex text-center">
                                    <vue-feather class="mx-auto text-center" type="cloud-lightning" size="20" />
                                    <h3 class="text-center">
                                        Capabilities
                                    </h3>
                                </div>
                                <div class="col-md-4 px-0 d-none d-lg-flex text-center">
                                    <vue-feather class="mx-auto" type="alert-triangle" size="20" />
                                    <h3 class="text-center">
                                        Limitations
                                    </h3>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-4 px-0">
                                    <div class="card shadow-none bg-transparent border-primary mb-50">
                                        <div class="card-body p-50">
                                            <p @click="chatStore.message = 'Write me a dispute letter to Amex using this account 45353XXXXX'" class="p-cursor card-text">
                                                "Write me a dispute letter to Amex using this account 45353XXXXX" <vue-feather type="arrow-right" size="14" />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 px-50 d-none d-lg-flex">
                                    <div class="card shadow-none bg-transparent border-primary mb-50">
                                        <div class="card-body p-50">
                                            <p class="card-text">
                                                Remembers what user said earlier in the conversation
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 px-0 d-none d-lg-flex">
                                    <div class="card shadow-none bg-transparent border-primary mb-50">
                                        <div class="card-body p-50">
                                            <p class="card-text">
                                                May occasionally generate incorrect information
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-4 px-0">
                                    <div class="card shadow-none bg-transparent border-primary mb-50">
                                        <div class="card-body p-50">
                                            <p @click="chatStore.message = 'What is 15 USC 1666b for late payments'" class="p-cursor card-text">
                                                "What is 15 USC 1666b for late payments" <vue-feather type="arrow-right" size="14" />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 px-50 d-none d-lg-flex">
                                    <div class="card shadow-none bg-transparent border-primary mb-50">
                                        <div class="card-body p-50">
                                            <p class="card-text">
                                                Allows user to provide follow-up corrections
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 px-0 d-none d-lg-flex">
                                    <div class="card shadow-none bg-transparent border-primary mb-50">
                                        <div class="card-body p-50">
                                            <p class="card-text">
                                                May occasionally produce biased content
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-4 px-0">
                                    <div class="card shadow-none bg-transparent border-primary mb-50">
                                        <div class="card-body p-50">
                                            <p @click="chatStore.message = 'How to write a Dispute Letter'" class="p-cursor card-text">
                                                "How to write a Dispute Letter" <vue-feather type="arrow-right" size="14" />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 px-50 d-none d-lg-flex">
                                    <div class="card shadow-none bg-transparent border-primary mb-50">
                                        <div class="card-body p-50">
                                            <p class="card-text">
                                                Trained to decline inappropriate requests
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 px-0 d-none d-lg-flex">
                                    <div class="card shadow-none bg-transparent border-primary mb-50">
                                        <div class="card-body p-50">
                                            <p class="card-text">
                                                Limited knowledge of world and events after 2021
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="chat-app-form w-100 mt-auto" action="javascript:void(0);">
                                <div class="input-group input-group-merge form-send-message">
                                    <input v-model="chatStore.message" type="text" class="form-control message" placeholder="Type your message i.e 'Write me a dispute letter to Amex using this account 45353XXX'" />
                                </div>
                                <button
                                    id="create-1"
                                    type="button"
                                    class="btn btn-primary mx-1"
                                    :key="chatStore.sendButtonKey"
                                    @click.once="
                                        chatStore.newConversation();
                                        chatStore.sendMessage();
                                    "
                                >
                                    <template v-if="chatStore.isSending">
                                        <span class="spinner-border spinner-border-sm mr-50" role="status" aria-hidden="true"></span>
                                        <span>Creating...</span>
                                    </template>
                                    <template v-else>
                                        <vue-feather type="send" class="d-lg-none" size="14" />
                                        <span class="d-none d-lg-block">
                                            Create
                                        </span>
                                    </template>
                                    <b-popover
                                        target="create-1"
                                        placement="top"
                                        triggers="hover"
                                        :html="true"
                                    >
                                        <template #title>
                                            {{ localizationStore.translate("chat.pricing.title") }}
                                        </template>
                                        <div class="row">
                                            <div class="col-12">
                                                <p v-if="planStore.openAI.serviceCharges.type == planStore.openAI.serviceCharges.fixed">
                                                    {{ localizationStore.translate("chat.pricing.message", { credit: planStore.getPrice('chat') }) }}
                                                </p>
                                                <p v-else>
                                                    {{ localizationStore.translate("chat.pricing.dynamic.message") }}
                                                </p>
                                            </div>
                                        </div>
                                    </b-popover>
                                </button>
                                <button
                                    data-toggle="modal"
                                    data-target="#top-up-modal"
                                    class="btn btn-outline-primary"
                                    type="button"
                                >
                                    <vue-feather type="plus" class="d-lg-none" size="14" />
                                    <span class="d-none d-lg-block">
                                        {{ localizationStore.translate("top.up.modal.title") }}
                                    </span>
                                </button>
                            </div>
                            <!-- <div class="mb-1 start-chat-icon">
                                <vue-feather type="message-square" size="14" />
                            </div>
                            <h4 @click="chatStore.newConversation()" class="sidebar-toggle start-chat-text">Start Conversation</h4> -->
                        </div>
                        <div v-show="chatStore.activeChat.id" class="active-chat">
                            <div class="chat-navbar">
                                <header class="chat-header">
                                    <div class="d-flex align-items-center">
                                        <div @click="showChat = !showChat" class="sidebar-toggle d-block d-lg-none mr-1">
                                            <vue-feather type="menu" class="font-medium-5" size="14" />
                                        </div>
                                        <div class="avatar avatar-border m-0 mr-1">
                                            <img src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/creditfixrr.jpg" alt="avatar" height="36" width="36" />
                                        </div>
                                        <h6 class="mb-0">{{ chatStore.activeChat.title }}</h6>
                                    </div>
                                </header>
                            </div>
                            <div id="user-conversation" class="user-chats">
                                <div class="chats">
                                    <div v-if="chatStore.conversations.isLoading" class="d-flex align-items-center justify-content-center">
                                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                        <span class="ml-25 align-middle">Loading...</span>
                                    </div>
                                    <div
                                        v-if="chatStore.conversations.data.length > 0"
                                        v-for="conversation in chatStore.conversations.data"
                                        class="chat"
                                        :class="{ 'chat-left': conversation.sender_id == 0 }"
                                    >
                                        <div class="chat-avatar">
                                            <span class="avatar box-shadow-1 cursor-pointer">
                                                <img
                                                    src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/creditfixrr.jpg"
                                                    alt="avatar"
                                                    height="36"
                                                    width="36"
                                                />
                                            </span>
                                        </div>
                                        <div class="chat-body">
                                            <div class="chat-content">
                                                <vue-feather :data-clipboard-text="conversation.message" class="copy-message float-right" type="copy" size="14" />
                                                <p v-html="conversation.message"></p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="divider">
                                        <div class="divider-text">Yesterday</div>
                                    </div>
                                    <div class="chat">
                                        <div class="chat-avatar">
                                            <span class="avatar box-shadow-1 cursor-pointer">
                                                <img
                                                    src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/creditfixrr.jpg"
                                                    alt="avatar"
                                                    height="36"
                                                    width="36"
                                                />
                                            </span>
                                        </div>
                                        <div class="chat-body">
                                            <div class="chat-content">
                                                <p>Absolutely!</p>
                                            </div>
                                            <div class="chat-content">
                                                <p>Vuexy admin is the responsive bootstrap 4 admin template.</p>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                            <div class="chat-app-form" action="javascript:void(0);">
                                <div class="input-group input-group-merge form-send-message">
                                    <input v-model="chatStore.message" type="text" class="form-control message" placeholder="Type your message i.e 'Write me a dispute letter to Amex using this account 45353XXX'" />
                                </div>
                                <button
                                    id="create-2"
                                    type="button"
                                    class="btn btn-primary mx-1"
                                    :key="chatStore.sendButtonKey"
                                    @click.once="chatStore.sendMessage()"
                                >
                                    <template v-if="chatStore.isSending">
                                        <span class="spinner-border spinner-border-sm mr-50" role="status" aria-hidden="true"></span>
                                        <span>Creating...</span>
                                    </template>
                                    <template v-else>
                                        <vue-feather type="send" class="d-lg-none" size="14" />
                                        <span class="d-none d-lg-block">
                                            Create
                                        </span>
                                    </template>
                                    <b-popover
                                        target="create-2"
                                        placement="top"
                                        triggers="hover"
                                        :html="true"
                                    >
                                        <template #title>
                                            {{ localizationStore.translate("chat.pricing.title") }}
                                        </template>
                                        <div class="row">
                                            <div class="col-12">
                                                <p v-if="planStore.openAI.serviceCharges.type == planStore.openAI.serviceCharges.fixed">
                                                    {{ localizationStore.translate("chat.pricing.message", { credit: planStore.getPrice('chat') }) }}
                                                </p>
                                                <p v-else>
                                                    {{ localizationStore.translate("chat.pricing.dynamic.message") }}
                                                </p>
                                            </div>
                                        </div>
                                    </b-popover>
                                </button>
                                <button
                                    data-toggle="modal"
                                    data-target="#top-up-modal"
                                    class="btn btn-outline-primary"
                                    type="button"
                                >
                                    <vue-feather type="plus" class="d-lg-none" size="14" />
                                    <span class="d-none d-lg-block">
                                        {{ localizationStore.translate("top.up.modal.title") }}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <update-chat-modal v-if="chatStore.activeChat.id" :id="chatStore.updateChatModalId"/>
        <payment-modal
            :id="'top-up-modal'"
            :top-up-type="topUpType"
        >
            <template #header>
                <div class="d-flex">
                    <img :src="settingStore.modalLogo" class="mb-2 w-50 mx-auto" alt="creditfixrr">
                </div>
                <h3 class="text-primary text-center mb-1">
                    {{ localizationStore.translate("top.up.modal.title") }}
                </h3>
                <div v-if="error" class="alert alert-danger mt-1 alert-validation-msg" role="alert">
                    <div class="alert-body d-flex align-items-center">
                        <vue-feather type="info" size="14" class="mr-50 align-middle top-0" />
                        <span v-html="message"></span>
                    </div>
                </div>
                <template v-for="(topUp, name) in planStore.topUps">
                    <input
                        type="radio"
                        name="top-up-type"
                        v-model="topUpType"
                        :value="name"
                        :id="`top-up-${name}`"
                        class="custom-control-input"
                    />
                    <label :for="`top-up-${name}`" class="card radio-box mb-50">
                        <div class="card-body p-75">
                            <div class="d-flex justify-content-between flex-wrap">
                                <h6 class="font-weight-bolder mb-0">
                                    {{ localizationStore.translate(`top.up.modal.package.${name}.title`) }}
                                </h6>
                                <h6 class="font-weight-bolder mb-0">
                                    {{ localizationStore.translate(`top.up.modal.package.${name}.price`, { price: `$${topUp.price}` }) }}
                                </h6>
                            </div>
                            <p
                                class="card-text"
                                v-html="localizationStore.translate(`top.up.modal.package.${name}.description`, { price: `$${topUp.price}`, credit: topUp.credit })"
                                
                            ></p>
                        </div>
                    </label>
                </template>
            </template>
            <template #footer="{ topUp }">
                <div class="row gy-1 gx-2 mt-75">
                    <div class="col-12 text-center">
                        <button type="button" @click.once="topUp" class="btn btn-primary mr-1 mt-1" :key="planStore.paymentBtnKey">
                            {{ localizationStore.translate("top.up.modal.button.save") }}
                        </button>
                        <button @click="hideModal('#top-up-modal')" type="reset" class="btn btn-outline-secondary mt-1" aria-label="Close">
                            {{ localizationStore.translate("top.up.modal.button.cancel") }}
                        </button>
                    </div>
                </div>
            </template>
        </payment-modal>
    </section>
    
</template>
<script>
    import { ref, reactive, computed, onUpdated, watch, onMounted, onUnmounted } from 'vue'
    import moment from 'moment';
    import { useChatStore } from '../../stores/ChatStore.js'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js';
    import { usePlanStore } from '../../stores/PlanStore.js'
    import { useSettingStore } from '../../stores/SettingStore.js'
    import Swal from 'sweetalert2'
    import { openModal, hideModal, centToDollar, formatDate } from '../../utilities/_helpers'
    import { fix, add } from 'mathjs'
    import PerfectScrollbar from 'perfect-scrollbar';
    import PaymentModal from '../modals/PaymentComponent'
    import UpdateChatModal from './UpdateChatModal';
    import Clipboard from 'clipboard';
    import { BPopover } from 'bootstrap-vue-3'
    export default {
        name: 'Chat',
        components: {
            PaymentModal,
            UpdateChatModal,
            BPopover,
        },
        setup(props) {
            return {
                moment: moment,
                centToDollar: centToDollar,
                formatDate: formatDate,
                chatStore: useChatStore(),
                localizationStore: useLocalizationStore(),
                planStore: usePlanStore(),
                settingStore: useSettingStore(),
                openModal: openModal,
                hideModal: hideModal,
                showChat: ref(false),
                topUpType: ref(null)
            }
        },
        mounted() {
            const $this = this;
            const route = $this.$router.resolve(
                {
                    name: 'chat-index'
                }
            );
            $this.chatStore.chats.data.length = 0;
            $this.chatStore.psChat = new PerfectScrollbar('.chat-user-list-wrapper');
            $this.chatStore.psConversation = new PerfectScrollbar('.user-chats');
            document.getElementById("chat-list").addEventListener('ps-y-reach-end', function () {
                if (
                    ($this.chatStore.chats.isLoading == false)
                    &&
                    !_.isNull($this.chatStore.chats.next_page_url)
                ) {
                    $this.chatStore.fetchChats($this.chatStore.chats.next_page_url);
                }
            });
            if ($this.chatStore.chats.isLoading == false) {
                $this.chatStore.fetchChats(route.href);
            }
            var clipboard = new Clipboard('.copy-message');
            clipboard.on('success', function (e) {
                e.clearSelection();
                toastr.success('Copied!');
            });
            clipboard.on('error', function (e) {
                console.error('Action:', e.action);
                console.error('Trigger:', e.trigger);
            });
        },
        watch: {
            'chatStore.chats.title' (newTitle, oldTitle) {
                const route = this.$router.resolve(
                    {
                        name: 'chat-index'
                    }
                );
                let isSearch = true;
                this.chatStore.fetchChats(route.href, isSearch);
            }
        },
        methods: {
        }
    }
</script>